module.exports = __webpack_public_path__ + "img/product1.45cc1bec.png";